/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_My_BookingsInputs */

const en_landing_nav_my_bookings = /** @type {(inputs: Landing_Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My bookings`)
};

const pl_landing_nav_my_bookings = /** @type {(inputs: Landing_Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje rezerwacje`)
};

/**
* | output |
* | --- |
* | "My bookings" |
*
* @param {Landing_Nav_My_BookingsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_nav_my_bookings = /** @type {((inputs?: Landing_Nav_My_BookingsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_My_BookingsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_nav_my_bookings(inputs)
	return en_landing_nav_my_bookings(inputs)
});